import type { Feature, FeatureModule } from '../../../types';
import { featureList } from '../../helpers';
import { CALENDAR_BUILDER_FEATURE_GROUP } from './group';

export const CALENDAR_BUILDER_FEATURES = {
  ACCESS: {
    guid: '1808d649-8854-4963-9bce-2f8c10f20001',
    name: 'calendar-builder:access',
    description: 'Access the Calendar Builder app',
    action: 'read',
    product: 'app',
    parentGuid: CALENDAR_BUILDER_FEATURE_GROUP.guid,
  },
} as const satisfies Record<string, Feature>;

export { CALENDAR_BUILDER_FEATURE_GROUP } from './group';

export const CALENDAR_BUILDER_MODULE: FeatureModule = {
  product: 'app',
  groups: [CALENDAR_BUILDER_FEATURE_GROUP],
  features: featureList(CALENDAR_BUILDER_FEATURES),
};
